import TouchableOpacity from '../Pressable';

export default TouchableOpacity;
